import { COLOR_CONTRAST } from '../App.types'

const convertHexToRgb = (hex: string) => {
  let hexCode = hex.substring(1)

  // Expand shorthand hex (#fff → #ffffff)
  if (hexCode.length === 3) {
    hexCode = hexCode
      .split('')
      .map((char) => char + char)
      .join('')
  }

  return [
    parseInt(hexCode.substring(0, 2), 16),
    parseInt(hexCode.substring(2, 4), 16),
    parseInt(hexCode.substring(4, 6), 16),
  ]
}

const convertRgbStringToRgbArray = (rgbString: string): Array<number> => {
  const rgbNumbers = rgbString.match(/\d+/g)
  if (rgbNumbers && rgbNumbers.length === 3) {
    return rgbNumbers.map(Number)
  } else {
    throw new Error('Invalid RGB format')
  }
}

const getLuminance = ([red, green, blue]: [number, number, number]) => {
  return (0.2126 * red) / 255 + (0.7152 * green) / 255 + (0.0722 * blue) / 255
}

// Given a color (hex code or rgb) - determine if the contrasting color should be light or dark.
// Depending on how we use this moving forward, maybe we find a better name or helper function.
export const getColorContrast = (hexOrRgb: string) => {
  // Convert hex to RGB
  let rgb: Array<number> = []

  if (hexOrRgb.startsWith('#')) {
    rgb = convertHexToRgb(hexOrRgb)
  } else if (hexOrRgb.startsWith('rgb')) {
    rgb = convertRgbStringToRgbArray(hexOrRgb)
  } else {
    throw new Error('Invalid input format')
  }

  // Calculate relative luminance
  const [red, green, blue] = rgb
  const luminance = getLuminance([red, green, blue])

  // Choose contrasting color based on luminance
  return luminance > 0.5 ? COLOR_CONTRAST.DARK : COLOR_CONTRAST.LIGHT
}
